<template>
  <div class="company-card" @click="handleClick(company)">
    <div class="company-image-container">
      <img
        v-if="company.logo"
        :src="BasrUrl + company.logo"
        :alt="company.name"
        class="company-image"
      />
      <div v-else class="company-image-placeholder">
        <div class="placeholder-text">{{ company.name }}</div>
      </div>
      <div v-if="company.rating" class="company-rating">
        <span class="rating-star">★</span>
        <span class="rating-value">{{ company.rating.toFixed(1) }}</span>
      </div>
    </div>
    <div class="company-content">
      <div class="company-header">
        <h3 class="company-name" :title="company.name">{{ company.name }}</h3>
        <div v-if="company.featured" class="featured-badge">推荐</div>
      </div>

      <div class="company-types">
        <!--        <span-->
        <!--            v-for="(type, index) in company.types"-->
        <!--            :key="index"-->
        <!--            class="type-tag"-->
        <!--            :style="{ backgroundColor: getTagColor(index) }"-->
        <!--        >-->
        <!--          {{ getBusiness(company.businessType) }}-->
        <!--        </span>-->
        <span class="type-tag" :style="{ backgroundColor: getTagColor(0) }">
          {{ getBusiness(company.businessType) }}
        </span>
      </div>

      <div class="company-description" v-if="company.description">
        <p>{{ company.description }}</p>
      </div>

      <div class="company-details">
        <div class="detail-item">
          <div class="icon-box">
            <i class="icon icon-location"></i>
          </div>
          <div class="address">{{ company.address }}</div>
        </div>
        <div class="detail-item">
          <i class="icon icon-phone"></i>
          <span class="phone">{{ PhoneNumber(company.phone) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { maskPhoneNumber } from '@/util/maskPhoneNumber';
export default {
  name: 'CompanyCard',
  props: {
    company: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      empty: require('@/assets/recycling/index/empty.svg'),
      BasrUrl: process.env.VUE_APP_BASE_URL,
    };
  },
  methods: {
    getBusiness(type) {
      const typeMap = {
        all: '全部',
        recycleStation: '回收网点',
        transferStation: '中转站',
        sortingCenter: '分拣中心',
        wasteEnterprise: '利废企业',
        dismantlingCenter: '二手交易市场',
        industrialPark: '产业园区/集散市场',
        other: '其他',
      };
      return typeMap[type] || type;
    },
    PhoneNumber(phone) {
      if (!phone) return '暂无';
      let nums;
      let userInfo = JSON.parse(localStorage.getItem('ordinaryUser'));
      let vipStartTime = userInfo?.userDetail?.memberStartTime || false;
      let vipEndTime = userInfo?.userDetail?.memberEndTime || false;
      let nowTime = new Date().getTime();
      let userType = userInfo?.userDetail?.userType || null;
      if (vipStartTime && vipEndTime) {
        if (
          nowTime > new Date(vipStartTime).getTime() &&
          nowTime < new Date(vipEndTime).getTime()
        ) {
          nums = phone;
        }
      } else if (userType == 3) {
        nums = phone;
      } else {
        let options = {
          maskChar: '*',
          maskLength: 4,
        };
        nums = maskPhoneNumber(phone, options);
      }
      return nums;
    },
    handleClick(company) {
      this.$emit('card-click', company);
      console.log(company, 'companycompanycompany');
    },
    getTagColor(index) {
      const colors = ['#e3f2fd', '#e8f5e9', '#fff8e1', '#fce4ec', '#f3e5f5'];
      return colors[index % colors.length];
    },
  },
};
</script>

<style lang="less" scoped>
.company-card {
  display: flex;
  width: 100%;
  max-width: 650px;
  height: 240px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  background-color: #fff;
  cursor: pointer;
  position: relative;
}

.company-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
}

.company-image-container {
  width: 220px;
  height: 100%;
  overflow: hidden;
  flex-shrink: 0;
  position: relative;
}

.company-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.company-card:hover .company-image {
  transform: scale(1.05);
}

.company-rating {
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: rgba(255, 255, 255, 0.9);
  padding: 4px 8px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  font-size: 14px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.rating-star {
  color: #ffc107;
  margin-right: 4px;
}

.rating-value {
  font-weight: bold;
  color: #333;
}

.company-content {
  flex: 1;
  padding: 18px 20px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.company-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;
}

.company-name {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* 限制行数 */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.featured-badge {
  background-color: #ff5252;
  color: white;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: bold;
  margin-left: 8px;
  flex-shrink: 0;
}

.company-types {
  margin: 8px 0;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.type-tag {
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  color: #424242;
  font-weight: 500;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.company-description {
  flex: 1;
  margin: 8px 0;
  font-size: 14px;
  color: #616161;
  line-height: 1.5;
  p {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}

.company-details {
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.detail-item {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #616161;
}
.phone,
.address {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.address {
  width: calc(100% - 16px);
}
.icon {
  width: 16px;
  height: 16px;
  margin-right: 8px;
  background-size: contain;
  background-repeat: no-repeat;
}
.icon-location {
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%23616161"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/></svg>');
}

.icon-phone {
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%23616161"><path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56-.35-.12-.74-.03-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"/></svg>');
}

@media (max-width: 768px) {
  .company-card {
    flex-direction: column;
    height: auto;
    max-width: 350px;
  }

  .company-image-container {
    width: 100%;
    height: 160px;
  }

  .company-content {
    padding: 14px;
  }

  .company-name {
    white-space: normal;
    font-size: 16px !important;
  }
  .type-tag {
    font-size: 12px !important;
  }
  .company-description {
    font-size: 12px !important;
  }
  .icon-box {
    width: 14px !important;
    height: 14px !important;
    .icon-location {
      width: 14px !important;
      height: 14px !important;
      background-size: 14px !important;
    }
  }
  .address{
    font-size: 12px !important;
  }
  .icon-phone{
    width: 14px !important;
    height: 14px !important;
    background-size: 14px !important;
  }
  .phone{
    font-size: 12px !important;
  }
}
.icon-box {
  width: 16px;
  height: 16px;
  .icon-location {
    display: flex;
    width: 16px;
    height: 16px;
    background-size: 16px;
  }
}
.company-image-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 20px;
  box-sizing: border-box;

  .placeholder-text {
    color: #2c3e50;
    font-size: 20px;
    font-weight: 600;
    text-align: center;
    line-height: 1.3;
    word-break: break-word;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;

    @media (max-width: 768px) {
      font-size: 16px;
      -webkit-line-clamp: 2;
    }
  }
}
</style>
